export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UU",
		doublesTier: "DOU",
	},
	venusaurmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "UU",
		doublesTier: "DOU",
	},
	charizardmegax: {
		tier: "OU",
		doublesTier: "DOU",
	},
	charizardmegay: {
		tier: "UU",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
		doublesTier: "DOU",
	},
	blastoisemega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "UU",
		doublesTier: "DOU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "UU",
		doublesTier: "DOU",
	},
	beedrillmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pidgeotmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rattata: {
		tier: "LC",
	},
	rattataalola: {
		tier: "LC",
	},
	raticate: {
		tier: "UU",
		doublesTier: "DOU",
	},
	raticatealola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pikachu: {
		tier: "LC",
	},
	pikachustarter: {
		isNonstandard: null,
		tier: "UU",
		doublesTier: "DOU",
	},
	raichu: {
		tier: "UU",
		doublesTier: "DOU",
	},
	raichualola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
		doublesTier: "DOU",
	},
	sandslashalola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "OU",
		doublesTier: "DOU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "OU",
		doublesTier: "DOU",
	},
	clefairy: {
		tier: "LC",
	},
	clefable: {
		tier: "UU",
		doublesTier: "DOU",
	},
	vulpix: {
		tier: "LC",
	},
	vulpixalola: {
		tier: "LC",
	},
	ninetales: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ninetalesalola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	jigglypuff: {
		tier: "LC",
	},
	wigglytuff: {
		tier: "UU",
		doublesTier: "DOU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "UU",
		doublesTier: "DOU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "UU",
		doublesTier: "DOU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "UU",
		doublesTier: "DOU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dugtrioalola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	persian: {
		tier: "UU",
		doublesTier: "DOU",
	},
	persianalola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "UU",
		doublesTier: "DOU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
		doublesTier: "DOU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "OU",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	alakazammega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "UU",
		doublesTier: "DOU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	geodude: {
		tier: "LC",
	},
	geodudealola: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	graveleralola: {
		tier: "NFE",
	},
	golem: {
		tier: "UU",
		doublesTier: "DOU",
	},
	golemalola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowbromega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "UU",
		doublesTier: "DOU",
	},
	farfetchd: {
		tier: "UU",
		doublesTier: "DOU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "UU",
		doublesTier: "DOU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "UU",
		doublesTier: "DOU",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		tier: "LC",
	},
	muk: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mukalola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gengarmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	onix: {
		tier: "UU",
		doublesTier: "DOU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "UU",
		doublesTier: "DOU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "UU",
		doublesTier: "DOU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "UU",
		doublesTier: "DOU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "UU",
		doublesTier: "DOU",
	},
	exeggutoralola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "UU",
		doublesTier: "DOU",
	},
	marowakalola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hitmonlee: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hitmonchan: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lickitung: {
		tier: "UU",
		doublesTier: "DOU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "OU",
		doublesTier: "DOU",
	},
	chansey: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tangela: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kangaskhan: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kangaskhanmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "UU",
		doublesTier: "DOU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "UU",
		doublesTier: "DOU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
		doublesTier: "DOU",
	},
	mrmime: {
		tier: "UU",
		doublesTier: "DOU",
	},
	scyther: {
		tier: "UU",
		doublesTier: "DOU",
	},
	jynx: {
		tier: "UU",
		doublesTier: "DOU",
	},
	electabuzz: {
		tier: "UU",
		doublesTier: "DOU",
	},
	magmar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pinsir: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pinsirmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tauros: {
		tier: "UU",
		doublesTier: "DOU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gyaradosmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	lapras: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ditto: {
		tier: "UU",
		doublesTier: "DOU",
	},
	eevee: {
		tier: "LC",
	},
	eeveestarter: {
		isNonstandard: null,
		tier: "UU",
		doublesTier: "DOU",
	},
	vaporeon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	jolteon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	flareon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	porygon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
		doublesTier: "DOU",
	},
	aerodactyl: {
		tier: "OU",
		doublesTier: "DOU",
	},
	aerodactylmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	snorlax: {
		tier: "OU",
		doublesTier: "DOU",
	},
	articuno: {
		tier: "UU",
		doublesTier: "DOU",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
	},
	moltres: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "DOU",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegax: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegay: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meltan: {
		isNonstandard: null,
		tier: "UU",
		doublesTier: "DOU",
	},
	melmetal: {
		isNonstandard: null,
		tier: "OU",
		doublesTier: "DOU",
	},
};
